import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
export const MAX_CUSTOM_PAGES = 10;
export const DEFAULT_PAGE_TITLE = 'Custom page';
export const DEFAULT_DISPLAY_SCOPE = 'proposalOnly';
export const PDF_MAX_SIZE_BYTES = 10 * 1024 * 1024; // 10MB
export const isProposalAndAgreement = (page)=>page.displayScope === 'proposalAndAgreement';
export const sortedPages = (pages)=>[
        ...pages
    ].sort((a, b)=>a.displayOrder - b.displayOrder);
export const agreementPages = (pages)=>sortedPages(pages.filter((page)=>isProposalAndAgreement(page) && page.type !== 'video'));
export const reindexDisplayOrders = (pages)=>pages.map((page, index)=>_object_spread_props(_object_spread({}, page), {
            displayOrder: index
        }));
/**
 * Full custom pages experience (rendering, editing, creation, template CRUD)
 * is enabled when FF is on OR when the entity already has custom pages
 * (from migration or from when FF was previously on).
 * When this returns true, behavior is identical regardless of FF state.
 */ export const customPagesEnabled = (ffEnabled, pages)=>ffEnabled || pages.length > 0;
export const createBlankVideoPage = (id, displayOrder)=>({
        id,
        pageTitle: DEFAULT_PAGE_TITLE,
        displayOrder,
        displayScope: DEFAULT_DISPLAY_SCOPE,
        type: 'video',
        video: {
            videoUrl: ''
        }
    });
export const createBlankTextPage = (id, displayOrder, textId)=>({
        id,
        pageTitle: DEFAULT_PAGE_TITLE,
        displayOrder,
        displayScope: DEFAULT_DISPLAY_SCOPE,
        type: 'text',
        text: {
            textId
        }
    });
export const createBlankPdfPage = (id, displayOrder, pdfName, pdfFileName)=>({
        id,
        pageTitle: DEFAULT_PAGE_TITLE,
        displayOrder,
        displayScope: DEFAULT_DISPLAY_SCOPE,
        type: 'pdf',
        pdf: {
            pdfName,
            pdfFileName
        }
    });
